import donnees from './entretien-initial.v1.json' with { type: 'json' };

/** Entretien initial (#38), donnée commune à l'appel (M02) et à l'entretien d'accueil (D16) : questions et choix, dans l'ordre. */
export interface DonneeEntretienInitial {
  version: string;
  questions: readonly { code: string; question: string; options?: readonly { code: string; libelle: string }[] }[];
}

export const ENTRETIEN_INITIAL: DonneeEntretienInitial = donnees;
